<template>
  <div>
    <list
      row-key="LogId"
      ref="list"
      unit="操作日志"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="标题">
          <el-input v-model="params.Title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="params.LogType" placeholder="请输入类型" />
        </el-form-item>
        <el-form-item label="IP地址">
          <el-input v-model="params.Ip" placeholder="请输入IP地址" />
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Title" label="标题" min-width="110px" />
        <el-table-column prop="LogType" label="类型" />
        <el-table-column prop="Ip" label="IP" min-width="100px" />
        <el-table-column prop="AddTime" label="访问时间" width="170px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/web/viewLog").default,
      params: {
        Title: "",
        LogType: "",
        StartTime: this.$commonJs.getToday(),
        EndTime: this.$commonJs.getToday(),
        Ip: "",
      },
    };
  },
};
</script>